var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-footer',{attrs:{"app":"","color":"primary darken-1","dark":"","padless":""}},[_c('v-col',{staticClass:"py-2 text-center text-caption",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("KinderPlus")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }